<div class="center-content-area">
    <h2 class="center-page-heading">{{ "settings_share_page_heading" | translate }}</h2>
    <p class="center-page-description">{{ "settings_share_page_description" | translate }}</p>

    <h5>{{ "settings_share_friends_heading" | translate }}</h5>
    <p>{{ "settings_share_friends_description" | translate }}</p>

    <div class="flex flex-wrap mb-12 share-buttons">
        <button pButton type="button" class="p-button-raised p-button-text p-button-plain m-2" (click)="shareEmail()">
            <div style="width: 100px" class="flex items-center justify-center flex-col">
                <i class="pi pi-envelope" style="font-size: 3rem; margin-bottom: 0.2em; color: #e13030"></i>
                <div class="text-center">Email</div>
            </div>
        </button>

        <button pButton type="button" class="p-button-raised p-button-text p-button-plain m-2" (click)="shareLinkedIn()">
            <div style="width: 100px" class="flex items-center justify-center flex-col">
                <i class="pi pi-linkedin" style="font-size: 3rem; margin-bottom: 0.2em; color: #0077b5"></i>
                <div class="text-center">Linkedin</div>
            </div>
        </button>

        <button pButton type="button" class="p-button-raised p-button-text p-button-plain m-2" (click)="shareFacebook()">
            <div style="width: 100px" class="flex items-center justify-center flex-col">
                <i class="pi pi-facebook" style="font-size: 3rem; margin-bottom: 0.2em; color: #3b5998"></i>
                <div class="text-center">Facebook</div>
            </div>
        </button>

        <button pButton type="button" class="p-button-raised p-button-text p-button-plain m-2" (click)="shareWhatsapp()">
            <div style="width: 100px" class="flex items-center justify-center flex-col">
                <i class="pi pi-whatsapp" style="font-size: 3rem; margin-bottom: 0.2em; color: #25d366"></i>
                <div class="text-center">WhatsApp</div>
            </div>
        </button>

        <button pButton type="button" class="p-button-raised p-button-text p-button-plain m-2" (click)="shareTwitter()">
            <div style="width: 100px" class="flex items-center justify-center flex-col">
                <i class="pi pi-twitter" style="font-size: 3rem; margin-bottom: 0.2em; color: #55acee"></i>
                <div class="text-center">Twitter</div>
            </div>
        </button>

        <button pButton type="button" class="p-button-raised p-button-text p-button-plain m-2" (click)="shareReddit()">
            <div style="width: 100px" class="flex items-center justify-center flex-col">
                <i class="pi pi-reddit" style="font-size: 3rem; margin-bottom: 0.2em; color: #5f99cf"></i>
                <div class="text-center">Reddit</div>
            </div>
        </button>
    </div>

    <p-divider></p-divider>

    <h5>{{ "settings_share_social_heading" | translate }}</h5>
    <p class="mb-12">{{ "settings_share_social_description_1" | translate }} <br />{{ "settings_share_social_description_2" | translate }}</p>
    <p-divider></p-divider>
    <h5>{{ "settings_share_affiliate_heading" | translate }}</h5>
    <p class="mb-12">
        {{ "settings_share_social_description_3" | translate }}<br />
        <br />
        <a href="{{ 'settings_share_social_description_link' | translate }}" target="_blank" rel="noopener">
            {{ "settings_share_social_description_4" | translate }}
        </a>
    </p>
    <p class="mb-4">{{ "settings_share_affiliate_heading_2" | translate }}</p>
    <p>
        <a class="affiliate-button" (click)="redirectAffiliate()">
            {{ "settings_share_affiliate_description_2_linktext" | translate }}
        </a>
    </p>
</div>
